import * as React from 'react'
import { IndicatorsContainerProps, components } from 'react-select'
import { UserOption } from '../user-select.types'

export const IndicatorsContainer = (
  props: IndicatorsContainerProps<UserOption>
) => (
  <components.IndicatorsContainer
    {...props}
    className="mt-1 h-8 flex items-center cursor-pointer"
  />
)
